module.exports = __webpack_public_path__ + "static/media/orange_tick.9e703ec9.svg";